/*
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-12-18 11:31:11
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-12-18 13:47:27
 */
import http from './http';

export function sendEmail(data) {
    return http.postOne('jmcloud.homepage.sendEmail', data, true)
}

export function fetchLoginData() {
    return http.get('jmcloud.account.user.info')
}

export function fetchBindingList(data) {
    return http.postOne('jmcloud.account.binding.list', data)
}

export function cancelBind(data) {
    return http.postOne('jmcloud.account.binding.cancel', data)
}

export function fetchJnosProduct() {
    return http.get('jmcloud.account.binding.product.jnos')
}

export function fetchPinProduct() {
    return http.get('jmcloud.account.binding.product.pin')
}

export function fetchAgreement() {
    return http.get('jmcloud.account.binding.agreement')
}

export function bind(data) {
    return http.postOne('jmcloud.account.binding.submit', data)
}

export function settleList(data) {
    return http.postOne('jmcloud.account.settle.list', data)
}

export function entryProductById(id) {
    return http.postOne('jmcloud.account.entry.product', { productId: id })
}

export function fetchJnosProductSettle() {
    return http.get('jmcloud.account.settle.product.jnos')
}

export function fetchPinProductSettle() {
    return http.get('jmcloud.account.settle.product.pin')
}

export function fetchArea(data) {
    return http.postOne('jmcloud.account.settle.area', data);
}

export function fetchSector(data) {
    return http.postOne('jmcloud.account.settle.sector', data);
}

export function checkPin(data) {
    return http.postOne('jmcloud.account.settle.register.check', data);
}

export function settle(data) {
    return http.postOne('jmcloud.account.settle.submit', data);
}

export function getBindDetail(data) {
    return http.postOne('jmcloud.account.binding.detail', data);
}

export function fetchSettleDetail(data) {
    return http.postOne('jmcloud.account.settle.detail', data);
}

export function getMenus(data) {
    return http.postOne('jmcloud.studyCenter.menu.menuStructure', {
        type: 100
    });
}

export function getContent(data) {
    return http.postOne('jmcloud.studyCenter.menu.content', {
        titleId: data
    });
}